import _slicedToArray from "/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useControlledState as $4oA3P$useControlledState } from "@react-stately/utils";
function $fc909762b330b746$export$61c6a8c84e605fb6(props) {
  var _$4oA3P$useControlled = $4oA3P$useControlledState(props.isOpen, props.defaultOpen || false, props.onOpenChange),
    _$4oA3P$useControlled2 = _slicedToArray(_$4oA3P$useControlled, 2),
    isOpen = _$4oA3P$useControlled2[0],
    setOpen = _$4oA3P$useControlled2[1];
  return {
    isOpen: isOpen,
    setOpen: setOpen,
    open: function open() {
      setOpen(true);
    },
    close: function close() {
      setOpen(false);
    },
    toggle: function toggle() {
      setOpen(!isOpen);
    }
  };
}
export { $fc909762b330b746$export$61c6a8c84e605fb6 as useOverlayTriggerState };